"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterUnknown = exports.filterContext = exports.filterString = exports.ninReplacement = exports.ninFormatWithOptionalSpace = exports.filter = exports.filterLogBeforeSend = exports.filterRumBeforeSend = void 0;
const filterRumBeforeSend = (event, _context) => {
    handle(event);
    if (event.type === "resource") {
        event.resource.url = (0, exports.filterString)(event.resource.url);
    }
    if (event.type === "error") {
        event.error.message = (0, exports.filterString)(event.error.message);
    }
    return true;
};
exports.filterRumBeforeSend = filterRumBeforeSend;
const filterLogBeforeSend = (event) => {
    handle(event);
};
exports.filterLogBeforeSend = filterLogBeforeSend;
const handle = (event) => {
    event.view.url = (0, exports.filterString)(event.view.url);
    event.view.referrer = (0, exports.filter)(event.view.referrer);
};
const filter = (s) => {
    if (s) {
        return (0, exports.filterString)(s);
    }
    return undefined;
};
exports.filter = filter;
exports.ninFormatWithOptionalSpace = /(\d{6})\s?(\d{5})/g;
exports.ninReplacement = "*********";
const filterString = (s) => {
    return s.replace(exports.ninFormatWithOptionalSpace, exports.ninReplacement);
};
exports.filterString = filterString;
const filterContext = (context) => {
    if (context === undefined) {
        return undefined;
    }
    return Object.entries(context).reduce((filteredContext, [key, value]) => {
        if (typeof value === "string") {
            return Object.assign(Object.assign({}, filteredContext), { [key]: (0, exports.filterString)(value) });
        }
        else if (typeof value === "object" && value !== null) {
            return Object.assign(Object.assign({}, filteredContext), { [key]: (0, exports.filterContext)(value) });
        }
        else if (Array.isArray(value)) {
            return Object.assign(Object.assign({}, filteredContext), { [key]: value.map((element) => {
                    (0, exports.filterContext)(element);
                }) });
        }
        return Object.assign(Object.assign({}, filteredContext), { [key]: value });
    }, {});
};
exports.filterContext = filterContext;
const filterUnknown = (value) => {
    if (value instanceof Error) {
        const error = value;
        const filteredErrorMessage = (0, exports.filterString)(error.message || "");
        const filteredStackTrace = (0, exports.filterString)(error.stack || "");
        const filteredName = (0, exports.filterString)(error.name || "");
        const filteredError = new Error(filteredErrorMessage);
        filteredError.stack = filteredStackTrace;
        filteredError.name = filteredName;
        return filteredError;
    }
    return value;
};
exports.filterUnknown = filterUnknown;
//# sourceMappingURL=filter.js.map